import { IActionCreatorAsync } from 'core/actions/Actions.interfaces'
import { ITenant, IAccessScope } from 'reducers/Reducers.interfaces'


export interface TwoFactorAuthProps {
  account: ITenant
  updateDetails: () => void
  onCancel?: () => void
  accessScope?: IAccessScope
}
export interface TwoFactorAuthDispatchProps {
  enableMfa: IActionCreatorAsync
}

export enum IVerificationType {
  EMAIL = 'email_otp',
  CAC = 'cac',
  AUTHENTICATOR_APP = 'otp',
}

export type ExtendedTwoFactorAuthProps = TwoFactorAuthProps & TwoFactorAuthDispatchProps

